/**
 * Generated by orval 🍺
 * Do not edit manually.
 * parktool API
 * Share a few Q-Park parking spots: users register plates and book days, the backend puts the right plate on each spot.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  SpotInfo
} from '../models';

import { customFetch } from '../../fetcher.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getSpotsUrl = () => {




  return `/api/spots`
}

/**
 * @summary All spots in slice order, each with what is on it right now.
 */
export const spots = async ( options?: Parameters<typeof customFetch>[1]): Promise<SpotInfo[]> => {

  return customFetch<SpotInfo[]>(getSpotsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSpotsQueryKey = () => {
    return [
    `/api/spots`
    ] as const;
    }


export const getSpotsQueryOptions = <TData = Awaited<ReturnType<typeof spots>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spots>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSpotsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof spots>>> = ({ signal }) => spots({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof spots>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SpotsQueryResult = NonNullable<Awaited<ReturnType<typeof spots>>>
export type SpotsQueryError = unknown


export function useSpots<TData = Awaited<ReturnType<typeof spots>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof spots>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof spots>>,
          TError,
          Awaited<ReturnType<typeof spots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSpots<TData = Awaited<ReturnType<typeof spots>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spots>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof spots>>,
          TError,
          Awaited<ReturnType<typeof spots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSpots<TData = Awaited<ReturnType<typeof spots>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spots>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary All spots in slice order, each with what is on it right now.
 */

export function useSpots<TData = Awaited<ReturnType<typeof spots>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spots>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSpotsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






